module.exports = __webpack_public_path__ + "static/media/parajohn-logo.b9e319d9.png";